import { youtubeEmbedUrl, youtubeThumbnailUrl } from '../../lib/youtube';

type Props = {
  videoId: string;
  title: string;
  thumbnailUrl?: string;
  autoplay?: boolean;
};

export default function ResourcesPodcastPlayer({
  videoId,
  title,
  thumbnailUrl,
  autoplay = false,
}: Props) {
  const poster = thumbnailUrl ?? youtubeThumbnailUrl(videoId, 'maxres');

  return (
    <div
      className="resources-podcast-player"
      style={{
        backgroundImage: `url(${poster})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <iframe
        key={videoId}
        className="resources-podcast-player__iframe"
        src={youtubeEmbedUrl(videoId, autoplay)}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}
